import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxButtonModule, DxLoadPanelModule, DxPopupModule, DxTagBoxModule } from 'devextreme-angular';
import { ProductionReportViewerComponent } from './production-report-view.component';
import { ReportSettingsFormModule } from '../report-settings-form/report-settings-form.module';
import { ReportUnavailableComponent } from '../../report-unavailable/report-unavailable.component';
import { ReportEntityFilterModule } from '../../report-entity-filter/report-entity-filter.module';
import { ReportPdfActionsComponent } from '../../report-pdf-actions/report-pdf-actions.component';

@NgModule({
  declarations: [ProductionReportViewerComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    DxLoadPanelModule,
    DxTagBoxModule,
    DxButtonModule,
    ReportSettingsFormModule,
    ReportUnavailableComponent,
    ReportEntityFilterModule,
    ReportPdfActionsComponent,
  ],
  exports: [ProductionReportViewerComponent],
})
export class ProductionReportViewModule {}
